import React from 'react';
import Layout from '../../../components/Layout/Auth';
import Wrapper from '../../../components/Pages/Auth';
import Content from '../../../components/Pages/Auth/SignUp';
import { displayName } from '../../../config';

const SignUp = (): JSX.Element => {
  document.title = `${displayName}: Sign Up`;

  return (
    <Layout>
      <Wrapper
        title="Sign Up"
        titleStyle={{
          whiteSpace: "pre-line",
          textAlign: "center"
        }}
      >
        <Content />
      </Wrapper>
    </Layout>
  );
};

export default SignUp;
